import { createContext, useContext, useEffect, useState } from "react";
import { publicText, publicError } from './publicText';

export const translations = {
  ko: {
    nav: { contact: "문의" },
    hero: {
      eyebrow: "BRISBANE · GOLD COAST",
      tagline: "호주에서의 모든 순간, 우리가 함께합니다",
      sub: "에이전시, 호텔, 유학, 워킹홀리데이부터 손이 필요한 모든 일까지 — 한 번에 All Rounder.",
      ctaPrimary: "문의 보내기",
      ctaSecondary: "연락처 저장",
    },
    services: {
      eyebrow: "우리가 하는 일",
      title: "필요한 모든 서비스를 한 곳에서",
      items: [
        {
          key: "hotel",
          tag: "ACCOMMODATION",
          title: "숙소 · 정착 지원",
          desc: "쉐어하우스, 단기숙소, 한달살기 및 초기 정착 지원.",
        },
        {
          key: "study",
          tag: "STUDY · SCHOOLS",
          title: "어학연수 · 학교안내",
          desc: "학교 및 어학 과정 방향 안내 지원.",
        },
        {
          key: "wh",
          tag: "WORKING HOLIDAY",
          title: "워홀 · 초기정착",
          desc: "도착부터 정착, 일자리 연결까지 — 안심 출발 패키지.",
        },
        {
          key: "task",
          tag: "LOCAL SERVICE",
          title: "호주 현지 서비스",
          desc: "공항 픽업, 이사, 청소 및 각종 현지 지원 서비스.",
        },
        {
          key: "bbq",
          tag: "EVENT · AUG 7",
          title: "South Bank BBQ Party",
          desc: "8월 7일 · 사우스뱅크 파크 · 강가에서 즐기는 여름 BBQ. 재료·장비 모두 제공.",
        },
      ],
    },
    about: {
      eyebrow: "WHY ALL ROUNDER",
      title: "현지에서 직접, 끝까지 책임집니다",
      bullets: [
        "브리즈번 · 골드코스트 현지 팀 운영",
        "유학 · 워홀 누적 상담 경력",
        "한국어 응대, 카카오톡 상시 지원",
        "투명한 비용, 숨김 수수료 없음",
      ],
    },
    contact: {
      eyebrow: "CONTACT",
      title: "편하게 연락 주세요",
      phone: "전화",
      email: "이메일",
      location: "위치",
      kakao: "카카오톡",
      instagram: "인스타그램",
      saveVcf: "휴대폰에 저장",
    },
    form: {
      eyebrow: "INQUIRY",
      title: "문의하기",
      sub: "24시간 내로 답변드립니다.",
      name: "이름",
      namePh: "홍길동",
      email: "이메일",
      emailPh: "you@example.com",
      phone: "전화번호 (선택)",
      phonePh: "+82 10 0000 0000",
      service: "관심 서비스",
      servicePh: "서비스를 선택하세요",
      message: "문의 내용",
      messagePh: "어떤 도움이 필요하신가요?",
      submit: "문의 보내기",
      submitting: "전송 중...",
      successTitle: "문의가 접수되었습니다",
      successDesc: "최대한 빠르게 연락드리겠습니다.",
      errorTitle: "전송 실패",
      errorDesc: "잠시 후 다시 시도해 주세요.",
      validationTitle: "입력을 확인해 주세요",
      validationDesc: "필수 항목을 모두 입력해 주세요.",
      options: [
        { value: "hotel", label: "숙소 · 정착 지원" },
        { value: "study", label: "어학연수 · 학교안내" },
        { value: "working-holiday", label: "워홀 · 초기정착" },
        { value: "tasker", label: "호주 현지 서비스" },
        { value: "other", label: "기타" },
      ],
    },
    bbq: {
      back: "올라운더로 돌아가기",
      eyebrow: "South Bank Social · 8월 7일",
      sub_a: "BBQ, 음료, 스낵 그리고 새로운 친구들. 몸만 오세요, 함께 즐겨요!",
      cta: "자리 예약하기",
      spots: "자리 예약됨",
      details: "// 상세 정보",
      details_title: "South Bank\nQLD · 호주",
      date: "날짜",
      date_v: "금, 8월 7일",
      date_sub: "우천 무관 — 지붕있는 파빌리온 확보",
      time: "시간",
      time_v: "오후 5:00 – 8:00",
      time_sub: "4:45부터 도착해 그릴 함께 준비하세요",
      loc: "장소",
      loc_v: "South Bank Park",
      loc_sub: "강변 파빌리온 · The Wheel 근처",
      cap: "정원",
      cap_sub: "정원 도달 시 접수 마감",
      reg: "// 접수",
      reg_title: "자리를 확보하세요.",
      reg_sub: "카드로 바로 결제하고 자리를 확정하세요. 결제 즉시 확정 이메일이 발송됩니다.",
      rules: "// 하우스 룰",
      rules_title: "세 가지 원칙.\n먹기 전에 읽어주세요.",
      r1_t: "선착순",
      r1_b: "정원 50명. 자리가 차면 마감입니다 — 그릴 옆 자리를 미리 잡으세요.",
      r2_t: "학생증 지참",
      r2_b: "학생 요금으로 등록하셨다면 당일 학생증을 지참해 주세요.",
      r3_t: "모든게 준비되어있어요",
      r3_b: "고기·채소·양념·소스·음료·장비 전부 현장에 준비됩니다. 배고픈 상태로만 오세요.",
    },
    footer: {
      tagline: "All Rounder — Your Australia, Handled.",
      rights: "All rights reserved.",
    },
  },
  en: {
    nav: { contact: "Contact" },
    hero: {
      eyebrow: "BRISBANE · GOLD COAST",
      tagline: "Every moment in Australia, handled with us",
      sub: "Agency, hotels, study abroad, working holiday — plus anything else you need help with. All in one place.",
      ctaPrimary: "Send Inquiry",
      ctaSecondary: "Save Contact",
    },
    services: {
      eyebrow: "WHAT WE DO",
      title: "Every service you need, in one place",
      items: [
        {
          key: "hotel",
          tag: "ACCOMMODATION",
          title: "Accommodation · Settlement",
          desc: "Sharehouses, short stays, monthly rentals and initial settlement support.",
        },
        {
          key: "study",
          tag: "STUDY · SCHOOLS",
          title: "Language Study · School Info",
          desc: "Guidance on schools and language course pathways.",
        },
        {
          key: "wh",
          tag: "WORKING HOLIDAY",
          title: "Working Holiday · Settle In",
          desc: "Arrival, settlement and job connection — start your WH with confidence.",
        },
        {
          key: "task",
          tag: "LOCAL SERVICE",
          title: "Local Services",
          desc: "Airport pickup, moving, cleaning and various on-the-ground support.",
        },
        {
          key: "bbq",
          tag: "EVENT · AUG 7",
          title: "South Bank BBQ Party",
          desc: "Aug 7 · South Bank Park · fire-grilled meat by the river. All food & gear provided.",
        },
      ],
    },
    about: {
      eyebrow: "WHY ALL ROUNDER",
      title: "Local team. End-to-end accountability.",
      bullets: [
        "Locally operated in Brisbane · Gold Coast",
        "Years of study abroad & WH counseling",
        "Korean support, KakaoTalk anytime",
        "Transparent pricing, no hidden fees",
      ],
    },
    contact: {
      eyebrow: "CONTACT",
      title: "Reach out — we'd love to help",
      phone: "Phone",
      email: "Email",
      location: "Location",
      kakao: "KakaoTalk",
      instagram: "Instagram",
      saveVcf: "Save to phone",
    },
    form: {
      eyebrow: "INQUIRY",
      title: "Send us a message",
      sub: "We'll respond within 24 hours.",
      name: "Name",
      namePh: "John Doe",
      email: "Email",
      emailPh: "you@example.com",
      phone: "Phone (optional)",
      phonePh: "+61 4 0000 0000",
      service: "Service of interest",
      servicePh: "Select a service",
      message: "Your message",
      messagePh: "How can we help you?",
      submit: "Send Inquiry",
      submitting: "Sending...",
      successTitle: "Inquiry received",
      successDesc: "We'll get back to you as soon as possible.",
      errorTitle: "Failed to send",
      errorDesc: "Please try again in a moment.",
      validationTitle: "Please check your input",
      validationDesc: "All required fields must be filled.",
      options: [
        { value: "hotel", label: "Accommodation · Settlement" },
        { value: "study", label: "Language Study · School Info" },
        { value: "working-holiday", label: "Working Holiday · Settle In" },
        { value: "tasker", label: "Local Services" },
        { value: "other", label: "Other" },
      ],
    },
    bbq: {
      back: "Back to All Rounder",
      eyebrow: "South Bank Social · Aug 7",
      sub_a: "BBQ, drinks, snacks & new friends. Just bring yourself and join the fun!",
      cta: "Reserve Your Spot",
      spots: "spots taken",
      details: "// The Details",
      details_title: "South Bank\nQLD · Australia",
      date: "Date",
      date_v: "Fri, Aug 7",
      date_sub: "Rain or shine — covered pavilion secured",
      time: "Time",
      time_v: "5:00 – 8:00 PM",
      time_sub: "Arrive from 4:45 to help fire the grill",
      loc: "Location",
      loc_v: "South Bank Park",
      loc_sub: "Riverside pavilion · closest to the Wheel",
      cap: "Capacity",
      cap_sub: "Registration closes when full",
      reg: "// Registration",
      reg_title: "Claim your seat.",
      reg_sub: "Pay securely by card to lock in your spot. Confirmation email lands right after payment.",
      rules: "// House Rules",
      rules_title: "Three chapters.\nRead before you eat.",
      r1_t: "First come, first served",
      r1_b: "Registration is strictly limited to 50 attendees. Once the fire's full, it's full — reserve early to lock your seat by the grill.",
      r2_t: "Bring your student ID",
      r2_b: "Registered under the student rate? Bring a valid student ID on the night. It keeps the discount honest and the crew happy.",
      r3_t: "Everything is on us",
      r3_b: "All meat, vegetables, seasonings, sauces, soft drinks and BBQ equipment will be ready on site. Just show up hungry.",
    },
    footer: {
      tagline: "All Rounder — Your Australia, Handled.",
      rights: "All rights reserved.",
    },
  },
  zh: {
    nav: { contact: "联系" },
    hero: {
      eyebrow: "BRISBANE · GOLD COAST",
      tagline: "在澳大利亚的每一刻，我们都与您同行",
      sub: "代理预订、酒店、留学、打工度假，以及任何您需要的帮助 — 一站尽享 All Rounder。",
      ctaPrimary: "发送咨询",
      ctaSecondary: "保存联系方式",
    },
    services: {
      eyebrow: "我们的服务",
      title: "您需要的一切，都在这里",
      items: [
        {
          key: "hotel",
          tag: "ACCOMMODATION",
          title: "住宿 · 落地支持",
          desc: "合租屋、短期住宿、月租及初期落地支持。",
        },
        {
          key: "study",
          tag: "STUDY · SCHOOLS",
          title: "语言留学 · 选校指南",
          desc: "学校与语言课程方向指引。",
        },
        {
          key: "wh",
          tag: "WORKING HOLIDAY",
          title: "打工度假 · 落地支持",
          desc: "从抵达、安顿到找工作，安心开启打工度假。",
        },
        {
          key: "task",
          tag: "LOCAL SERVICE",
          title: "澳洲本地服务",
          desc: "机场接送、搬家、清洁等各类本地支持服务。",
        },
        {
          key: "bbq",
          tag: "EVENT · AUG 7",
          title: "南岸 BBQ 派对",
          desc: "8月7日 · South Bank Park · 河畔烧烤派对，食材与器材全部提供。",
        },
      ],
    },
    about: {
      eyebrow: "WHY ALL ROUNDER",
      title: "本地团队，全程负责",
      bullets: [
        "驻布里斯班 · 黄金海岸的本地团队",
        "多年留学 · 打工度假咨询经验",
        "韩语 · 英语沟通，KakaoTalk 全天在线",
        "透明定价，无隐藏费用",
      ],
    },
    contact: {
      eyebrow: "CONTACT",
      title: "随时联系我们",
      phone: "电话",
      email: "邮箱",
      location: "位置",
      kakao: "KakaoTalk",
      instagram: "Instagram",
      saveVcf: "保存到手机",
    },
    form: {
      eyebrow: "INQUIRY",
      title: "发送咨询",
      sub: "我们将在24小时内回复。",
      name: "姓名",
      namePh: "您的姓名",
      email: "邮箱",
      emailPh: "you@example.com",
      phone: "电话（选填）",
      phonePh: "+86 138 0000 0000",
      service: "感兴趣的服务",
      servicePh: "请选择服务",
      message: "咨询内容",
      messagePh: "我们能如何帮助您？",
      submit: "发送咨询",
      submitting: "发送中...",
      successTitle: "咨询已收到",
      successDesc: "我们将尽快与您联系。",
      errorTitle: "发送失败",
      errorDesc: "请稍后再试。",
      validationTitle: "请检查输入",
      validationDesc: "请填写所有必填项。",
      options: [
        { value: "hotel", label: "住宿 · 落地支持" },
        { value: "study", label: "语言留学 · 选校指南" },
        { value: "working-holiday", label: "打工度假 · 落地支持" },
        { value: "tasker", label: "澳洲本地服务" },
        { value: "other", label: "其他" },
      ],
    },
    bbq: {
      back: "返回 All Rounder",
      eyebrow: "South Bank Social · 8月7日",
      sub_a: "BBQ、饮品、小吃和新朋友。只需带上你自己，一起加入乐趣吧！",
      cta: "预约位置",
      spots: "个位置已预约",
      details: "// 详情",
      details_title: "South Bank\n昆士兰 · 澳大利亚",
      date: "日期",
      date_v: "周五, 8月7日",
      date_sub: "风雨无阻 — 有顶棚场地",
      time: "时间",
      time_v: "下午 5:00 – 8:00",
      time_sub: "4:45到场帮忙点火",
      loc: "地点",
      loc_v: "South Bank Park",
      loc_sub: "河畔亭 · 靠近摩天轮",
      cap: "人数",
      cap_sub: "满员即截止",
      reg: "// 登记",
      reg_title: "锁定你的位置。",
      reg_sub: "在线银行卡支付，立即锁定席位。付款后马上收到确认邮件。",
      rules: "// 规则",
      rules_title: "三条规则。\n请务必阅读。",
      r1_t: "先到先得",
      r1_b: "限50人。满员即止 — 提前预约锁定烧烤位。",
      r2_t: "携带学生证",
      r2_b: "以学生价登记？当晚请携带有效学生证。",
      r3_t: "一切我们准备",
      r3_b: "肉、蔬菜、调味料、饮料和器材全部现场准备就绪。饿着肚子来就好。",
    },
    footer: {
      tagline: "All Rounder — 您的澳洲，由我们打理。",
      rights: "版权所有。",
    },
  },
  ja: {
    nav: { contact: "問い合わせ" },
    hero: {
      eyebrow: "BRISBANE · GOLD COAST",
      tagline: "オーストラリアでのすべての瞬間、私たちと共に",
      sub: "エージェント、ホテル、留学、ワーホリから、お手伝いが必要なすべてのことまで — All Rounder で一括対応。",
      ctaPrimary: "お問い合わせ",
      ctaSecondary: "連絡先を保存",
    },
    services: {
      eyebrow: "サービス",
      title: "必要なすべてのサービスを、ここに",
      items: [
        {
          key: "hotel",
          tag: "ACCOMMODATION",
          title: "宿泊 · 定着サポート",
          desc: "シェアハウス、短期滞在、マンスリーステイ、初期定着まで対応。",
        },
        {
          key: "study",
          tag: "STUDY · SCHOOLS",
          title: "語学留学 · 学校案内",
          desc: "学校選び・語学コースの方向性をご案内。",
        },
        {
          key: "wh",
          tag: "WORKING HOLIDAY",
          title: "ワーホリ · 初期定着",
          desc: "到着・定着・お仕事探しまで — 安心スタートのワーホリパッケージ。",
        },
        {
          key: "task",
          tag: "LOCAL SERVICE",
          title: "オーストラリア現地サービス",
          desc: "空港送迎、引越し、清掃などの現地サポート全般。",
        },
        {
          key: "bbq",
          tag: "EVENT · AUG 7",
          title: "South Bank BBQ パーティー",
          desc: "8月7日 · South Bank Park · 川辺で楽しむ夏の BBQ。食材・器材すべて提供。",
        },
      ],
    },
    about: {
      eyebrow: "WHY ALL ROUNDER",
      title: "現地で直接、最後まで責任を持って",
      bullets: [
        "ブリスベン · ゴールドコースト現地チーム運営",
        "留学 · ワーホリの豊富な相談実績",
        "韓国語対応、KakaoTalk 常時サポート",
        "透明な料金、隠れた手数料なし",
      ],
    },
    contact: {
      eyebrow: "CONTACT",
      title: "お気軽にご連絡ください",
      phone: "電話",
      email: "メール",
      location: "所在地",
      kakao: "カカオトーク",
      instagram: "Instagram",
      saveVcf: "携帯に保存",
    },
    form: {
      eyebrow: "INQUIRY",
      title: "お問い合わせ",
      sub: "24時間以内にご返信いたします。",
      name: "お名前",
      namePh: "山田 太郎",
      email: "メール",
      emailPh: "you@example.com",
      phone: "電話番号（任意）",
      phonePh: "+61 4 0000 0000",
      service: "ご希望のサービス",
      servicePh: "サービスを選択",
      message: "お問い合わせ内容",
      messagePh: "どのようなお手伝いが必要ですか？",
      submit: "お問い合わせを送信",
      submitting: "送信中...",
      successTitle: "お問い合わせを受付ました",
      successDesc: "できるだけ早くご連絡いたします。",
      errorTitle: "送信に失敗",
      errorDesc: "しばらくしてから再度お試しください。",
      validationTitle: "入力をご確認ください",
      validationDesc: "必須項目をすべてご入力ください。",
      options: [
        { value: "hotel", label: "宿泊 · 定着サポート" },
        { value: "study", label: "語学留学 · 学校案内" },
        { value: "working-holiday", label: "ワーホリ · 初期定着" },
        { value: "tasker", label: "オーストラリア現地サービス" },
        { value: "other", label: "その他" },
      ],
    },
    bbq: {
      back: "All Rounder に戻る",
      eyebrow: "South Bank Social · 8月7日",
      sub_a: "BBQ、ドリンク、スナック、そして新しい仲間。手ぶらで来て、一緒に楽しもう！",
      cta: "席を予約する",
      spots: "席が予約済み",
      details: "// 詳細",
      details_title: "South Bank\nQLD · オーストラリア",
      date: "日付",
      date_v: "金, 8月7日",
      date_sub: "雨天決行 — 屋根付きパビリオン確保",
      time: "時間",
      time_v: "午後 5:00 – 8:00",
      time_sub: "4:45から到着してグリル準備",
      loc: "場所",
      loc_v: "South Bank Park",
      loc_sub: "川辺パビリオン · 観覧車の近く",
      cap: "定員",
      cap_sub: "満席で受付終了",
      reg: "// 登録",
      reg_title: "席を確保しよう。",
      reg_sub: "カードで即時決済して席を確定。決済後すぐに確認メールが届きます。",
      rules: "// ハウスルール",
      rules_title: "3つのルール。\n食べる前に読んで。",
      r1_t: "先着順",
      r1_b: "定員50名。満員になったら終了 — 早めに予約を。",
      r2_t: "学生証を持参",
      r2_b: "学生料金で登録した場合は当日、有効な学生証をお持ちください。",
      r3_t: "全て準備済み",
      r3_b: "肉・野菜・調味料・ソース・ドリンク・器材、全て現地に用意。空腹で来てください。",
    },
    footer: {
      tagline: "All Rounder — オーストラリアでのすべてを、私たちが。",
      rights: "All rights reserved.",
    },
  },
  es: {
    nav: { contact: "Contacto" },
    hero: {
      eyebrow: "BRISBANE · GOLD COAST",
      tagline: "Cada momento en Australia, gestionado con nosotros",
      sub: "Alojamiento, estudios de idiomas, working holiday y cualquier otra ayuda que necesites — todo con All Rounder.",
      ctaPrimary: "Enviar consulta",
      ctaSecondary: "Guardar contacto",
    },
    services: {
      eyebrow: "QUÉ HACEMOS",
      title: "Todos los servicios que necesitas, en un solo lugar",
      items: [
        {
          key: "hotel",
          tag: "ACCOMMODATION",
          title: "Alojamiento · Asentamiento",
          desc: "Sharehouses, estancias cortas, alquileres mensuales y apoyo inicial al llegar.",
        },
        {
          key: "study",
          tag: "STUDY · SCHOOLS",
          title: "Estudio de idiomas · Escuelas",
          desc: "Orientación sobre escuelas y rutas de cursos de idiomas.",
        },
        {
          key: "wh",
          tag: "WORKING HOLIDAY",
          title: "Working Holiday · Asentamiento",
          desc: "Llegada, asentamiento y conexión laboral — empieza tu WH con confianza.",
        },
        {
          key: "task",
          tag: "LOCAL SERVICE",
          title: "Servicios locales",
          desc: "Recogida en aeropuerto, mudanza, limpieza y diversos apoyos en el sitio.",
        },
        {
          key: "bbq",
          tag: "EVENT · AUG 7",
          title: "South Bank BBQ Party",
          desc: "7 de agosto · South Bank Park · BBQ junto al río. Comida y equipo incluidos.",
        },
      ],
    },
    about: {
      eyebrow: "WHY ALL ROUNDER",
      title: "Equipo local, responsabilidad de principio a fin",
      bullets: [
        "Equipo local en Brisbane · Gold Coast",
        "Años de experiencia en asesoría de estudios y WH",
        "Soporte en coreano, KakaoTalk siempre disponible",
        "Precios transparentes, sin tarifas ocultas",
      ],
    },
    contact: {
      eyebrow: "CONTACTO",
      title: "Contáctanos, estaremos encantados de ayudar",
      phone: "Teléfono",
      email: "Correo",
      location: "Ubicación",
      kakao: "KakaoTalk",
      instagram: "Instagram",
      saveVcf: "Guardar en el móvil",
    },
    form: {
      eyebrow: "CONSULTA",
      title: "Envíanos un mensaje",
      sub: "Respondemos en 24 horas.",
      name: "Nombre",
      namePh: "Juan García",
      email: "Correo",
      emailPh: "you@example.com",
      phone: "Teléfono (opcional)",
      phonePh: "+61 4 0000 0000",
      service: "Servicio de interés",
      servicePh: "Selecciona un servicio",
      message: "Tu mensaje",
      messagePh: "¿En qué podemos ayudarte?",
      submit: "Enviar consulta",
      submitting: "Enviando...",
      successTitle: "Consulta recibida",
      successDesc: "Te contactaremos lo antes posible.",
      errorTitle: "Error al enviar",
      errorDesc: "Por favor, inténtalo de nuevo en un momento.",
      validationTitle: "Por favor revisa tus datos",
      validationDesc: "Todos los campos obligatorios deben rellenarse.",
      options: [
        { value: "hotel", label: "Alojamiento · Asentamiento" },
        { value: "study", label: "Estudio de idiomas · Escuelas" },
        { value: "working-holiday", label: "Working Holiday · Asentamiento" },
        { value: "tasker", label: "Servicios locales" },
        { value: "other", label: "Otro" },
      ],
    },
    bbq: {
      back: "Volver a All Rounder",
      eyebrow: "South Bank Social · 7 de agosto",
      sub_a: "BBQ, bebidas, snacks y nuevos amigos. Solo trae contigo y únete a la diversión!",
      cta: "Reserva tu lugar",
      spots: "lugares tomados",
      details: "// Detalles",
      details_title: "South Bank\nQLD · Australia",
      date: "Fecha",
      date_v: "Vie, 7 de agosto",
      date_sub: "Llueva o truene — pabellón cubierto",
      time: "Hora",
      time_v: "5:00 – 8:00 PM",
      time_sub: "Llega desde las 4:45 para encender la parrilla",
      loc: "Ubicación",
      loc_v: "South Bank Park",
      loc_sub: "Pabellón junto al río · cerca de la Wheel",
      cap: "Capacidad",
      cap_sub: "El registro cierra al llenarse",
      reg: "// Registro",
      reg_title: "Asegura tu lugar.",
      reg_sub: "Paga con tarjeta para asegurar tu lugar. Email de confirmación justo después del pago.",
      rules: "// Reglas",
      rules_title: "Tres capítulos.\nLee antes de comer.",
      r1_t: "Por orden de llegada",
      r1_b: "Aforo máximo de 50 personas. Cuando la parrilla está llena, está llena — reserva pronto.",
      r2_t: "Trae tu credencial de estudiante",
      r2_b: "¿Registrado como estudiante? Trae credencial válida esa noche.",
      r3_t: "Todo por nuestra cuenta",
      r3_b: "Toda la carne, verduras, salsas, bebidas y equipo estarán listos. Ven con hambre.",
    },
    footer: {
      tagline: "All Rounder — Tu Australia, gestionada.",
      rights: "Todos los derechos reservados.",
    },
  },
  pt: {
    nav: { contact: "Contato" },
    hero: {
      eyebrow: "BRISBANE · GOLD COAST",
      tagline: "Cada momento na Austrália, cuidado por nós",
      sub: "Hospedagem, intercâmbio, working holiday e qualquer outra ajuda que você precisar — tudo com All Rounder.",
      ctaPrimary: "Enviar consulta",
      ctaSecondary: "Salvar contato",
    },
    services: {
      eyebrow: "O QUE FAZEMOS",
      title: "Todos os serviços que você precisa, num só lugar",
      items: [
        {
          key: "hotel",
          tag: "ACCOMMODATION",
          title: "Hospedagem · Instalação",
          desc: "Sharehouses, estadias curtas, aluguéis mensais e suporte inicial na chegada.",
        },
        {
          key: "study",
          tag: "STUDY · SCHOOLS",
          title: "Intercâmbio · Escolas",
          desc: "Orientação sobre escolas e cursos de idiomas.",
        },
        {
          key: "wh",
          tag: "WORKING HOLIDAY",
          title: "Working Holiday · Instalação",
          desc: "Chegada, instalação e conexão com trabalho — comece seu WH com confiança.",
        },
        {
          key: "task",
          tag: "LOCAL SERVICE",
          title: "Serviços locais",
          desc: "Transfer do aeroporto, mudança, limpeza e diversos apoios locais.",
        },
        {
          key: "bbq",
          tag: "EVENT · AUG 7",
          title: "South Bank BBQ Party",
          desc: "7 de agosto · South Bank Park · BBQ à beira do rio. Comida e equipamento incluídos.",
        },
      ],
    },
    about: {
      eyebrow: "WHY ALL ROUNDER",
      title: "Equipe local, responsabilidade do início ao fim",
      bullets: [
        "Equipe local em Brisbane · Gold Coast",
        "Anos de experiência em intercâmbio e WH",
        "Atendimento em coreano, KakaoTalk sempre disponível",
        "Preços transparentes, sem taxas ocultas",
      ],
    },
    contact: {
      eyebrow: "CONTATO",
      title: "Entre em contato — vamos adorar ajudar",
      phone: "Telefone",
      email: "E-mail",
      location: "Localização",
      kakao: "KakaoTalk",
      instagram: "Instagram",
      saveVcf: "Salvar no celular",
    },
    form: {
      eyebrow: "CONSULTA",
      title: "Envie sua mensagem",
      sub: "Respondemos em 24 horas.",
      name: "Nome",
      namePh: "João Silva",
      email: "E-mail",
      emailPh: "you@example.com",
      phone: "Telefone (opcional)",
      phonePh: "+61 4 0000 0000",
      service: "Serviço de interesse",
      servicePh: "Selecione um serviço",
      message: "Sua mensagem",
      messagePh: "Como podemos ajudar você?",
      submit: "Enviar consulta",
      submitting: "Enviando...",
      successTitle: "Consulta recebida",
      successDesc: "Entraremos em contato o quanto antes.",
      errorTitle: "Erro ao enviar",
      errorDesc: "Por favor, tente novamente em instantes.",
      validationTitle: "Verifique seus dados",
      validationDesc: "Todos os campos obrigatórios devem ser preenchidos.",
      options: [
        { value: "hotel", label: "Hospedagem · Instalação" },
        { value: "study", label: "Intercâmbio · Escolas" },
        { value: "working-holiday", label: "Working Holiday · Instalação" },
        { value: "tasker", label: "Serviços locais" },
        { value: "other", label: "Outro" },
      ],
    },
    bbq: {
      back: "Voltar para All Rounder",
      eyebrow: "South Bank Social · 7 de agosto",
      sub_a: "BBQ, bebidas, petiscos e novos amigos. Só chegar e curtir com a gente!",
      cta: "Reserve seu lugar",
      spots: "lugares reservados",
      details: "// Detalhes",
      details_title: "South Bank\nQLD · Austrália",
      date: "Data",
      date_v: "Sex, 7 de ago",
      date_sub: "Faça chuva ou sol — pavilhão coberto",
      time: "Horário",
      time_v: "5:00 – 8:00 PM",
      time_sub: "Chegue às 4:45 para ajudar a acender a churrasqueira",
      loc: "Local",
      loc_v: "South Bank Park",
      loc_sub: "Pavilhão à beira do rio · perto da Roda",
      cap: "Capacidade",
      cap_sub: "Inscrições encerram quando lotar",
      reg: "// Registro",
      reg_title: "Garanta seu lugar.",
      reg_sub: "Pague com cartão para garantir seu lugar. Email de confirmação logo após o pagamento.",
      rules: "// Regras",
      rules_title: "Três capítulos.\nLeia antes de comer.",
      r1_t: "Por ordem de chegada",
      r1_b: "Limite de 50 pessoas. Quando lotar, lotou — reserve cedo.",
      r2_t: "Traga sua carteira de estudante",
      r2_b: "Registrado como estudante? Traga carteira válida na noite.",
      r3_t: "Tudo por nossa conta",
      r3_b: "Toda carne, vegetais, temperos, molhos, bebidas e equipamento prontos no local. Venha com fome.",
    },
    footer: {
      tagline: "All Rounder — Sua Austrália, resolvida.",
      rights: "Todos os direitos reservados.",
    },
  },
};

const I18nContext = createContext({ lang: "ko", t: translations.ko, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "ko";
    const saved = localStorage.getItem("gcapt_lang");
    return translations[saved] ? saved : "ko";
  });

  useEffect(() => {
    localStorage.setItem("gcapt_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = { lang, setLang: next => { if (translations[next]) setLang(next); }, t: translations[lang], tx: (source, values) => publicText(lang, source, values), errorText: detail => publicError(lang,detail) };
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
